
export const getLinkConfig = () => ({
  href: {
    pathname: '/contact',
    query: {}
  },
  as: '/contactanos'
})

const CONTACT_ANALYTIC_ACTION_PATHS = {
  CONTACT_REQUESTED: 'contact-requested'
}

export const getAnalyticActionTrackerLink = (analyticAction) => {
  const linkConfig = getLinkConfig()

  linkConfig.as = `${linkConfig.as}/${CONTACT_ANALYTIC_ACTION_PATHS[analyticAction]}`

  return linkConfig
}
